module.exports = __webpack_public_path__ + "static/media/phd_programs.f7dc8eb7.jpg";